import { Injectable, OnInit, ElementRef } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { loadModules } from "esri-loader";
import esri = __esri;

@Injectable()
export class GisViewService{

    async getGroundZValue(longitude: number, latitude: number, map: esri.WebScene): Promise<esri.ElevationQueryResult> {
        const [Point] = await loadModules([
            "esri/geometry/Point"
        ]);

        var point = new Point({
            latitude: latitude,
            longitude: longitude
        });

        return map.ground.queryElevation(point); 
    }
}